export default __webpack_public_path__ + "static/media/Detail-member-IMG.1b3fe793.png";